<template>
  <div class="infinite-list-footer" role="status" aria-live="polite">
    <span v-if="loading">加载中...</span>
    <template v-else-if="error">
      <span>加载失败，请重试</span>
      <button type="button" @click="$emit('load')">重新加载</button>
    </template>
    <span v-else-if="hasMore">向下滚动加载更多</span>
    <span v-else-if="!empty">没有更多了</span>
  </div>
</template>

<script>
/**
 * 列表触底加载与状态提示，分页和请求由页面负责。
 * @author tz
 * @date 2026-09-17
 */
export default {
  name: 'InfiniteListFooter',
  props: {
    loading: Boolean,
    error: Boolean,
    hasMore: Boolean,
    empty: Boolean
  },
  computed: {
    canLoad () {
      return this.hasMore && !this.loading && !this.error
    }
  },
  watch: {
    canLoad (value) {
      // 首屏未填满或分页结束后仍接近底部时，继续加载。
      if (value) this.$nextTick(this.checkPosition)
    }
  },
  mounted () {
    this.observer = new IntersectionObserver(this.checkPosition, { rootMargin: '0px 0px 160px 0px' })
    this.observer.observe(this.$el)
  },
  beforeDestroy () {
    this.observer.disconnect()
  },
  methods: {
    checkPosition () {
      if (this._isDestroyed || !this.canLoad) return
      const rect = this.$el.getBoundingClientRect()
      if (rect.top <= window.innerHeight + 160 && rect.bottom >= 0) {
        this.$emit('load')
      }
    }
  }
}
</script>

<style scoped lang="less">
.infinite-list-footer {
  min-height: 44px;
  padding-top: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  color: #666;
  font-size: 14px;
}
.infinite-list-footer button {
  min-width: 112px;
  min-height: 44px;
  padding: 0 16px;
  border: 1px solid #367d79;
  background: #fff;
  color: #367d79;
  cursor: pointer;
}
.infinite-list-footer button:hover {
  background: #f1f8f7;
}
.infinite-list-footer button:focus-visible {
  outline: 2px solid #367d79;
  outline-offset: 2px;
}
</style>
